import { Box, styled } from '@mui/material';
import { WHITE } from 'constants/colors';

const StyledFooter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 40px;
  margin-top: 16px;
  box-sizing: border-box;
  background-color: ${WHITE};
  border: 1px solid #e0e0e0;
  border-radius: 0 0 4px 4px;
  font-family: 'signikaregular';
`;

interface FooterProps {
  children: React.ReactNode | React.ReactNode[];
}

const Footer = ({ children }: FooterProps) => {
  return <StyledFooter>{children}</StyledFooter>;
};

export default Footer;
